import { Link } from 'react-router-dom';

const policies = [
  {
    tag: '原則 1',
    title: '取得目的',
    desc: '当社は、サービスの提供・改善、お問合わせ対応のために個人情報を収集します。収集に際しては利用目的を明示し、目的外利用は行いません。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20Japanese%20office%20interior%20with%20clean%20minimalist%20design%2C%20wooden%20desk%2C%20open%20layout%2C%20natural%20daylight%20from%20large%20windows%2C%20professional%20corporate%20setting%2C%20no%20people%2C%20warm%20neutral%20tones&width=480&height=600&seq=privacy-policy-1&orientation=portrait',
  },
  {
    tag: '原則 2',
    title: '安全管理',
    desc: '個人情報への不正アクセス、漏洩、滅失を防止するため、技術的・組織的な安全管理措置を講じています。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20secure%20server%20room%20door%20with%20electronic%20keycard%20access%2C%20modern%20security%20infrastructure%2C%20minimalist%20corporate%20design%2C%20clean%20white%20walls%2C%20no%20people%2C%20professional%20atmosphere&width=480&height=600&seq=privacy-policy-2&orientation=portrait',
  },
  {
    tag: '原則 3',
    title: '第三者提供',
    desc: '法令に基づく場合を除き、個人情報を第三者に提供することはありません。業務委託先への提供時は厳格な管理監督を行います。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20Japanese%20law%20office%20with%20legal%20books%20on%20shelves%2C%20clean%20wooden%20desk%2C%20minimalist%20design%2C%20warm%20ambient%20lighting%2C%20no%20people%2C%20professional%20atmosphere&width=480&height=600&seq=privacy-policy-3&orientation=portrait',
  },
  {
    tag: '原則 4',
    title: '開示請求',
    desc: '保有個人データの開示、訂正、利用停止等の請求について、本人確認の上、法令に従い速やかに対応いたします。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20clean%20modern%20Japanese%20office%20with%20documents%20neatly%20organized%20on%20a%20desk%2C%20minimalist%20interior%2C%20natural%20daylight%2C%20professional%20corporate%20setting%2C%20no%20people%2C%20warm%20neutral%20tones&width=480&height=600&seq=privacy-policy-4&orientation=portrait',
  },
];

export default function Privacy() {
  return (
    <>
      {/* Hero */}
      <section className="relative h-[320px] md:h-[400px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20abstract%20photography%20of%20Tokyo%20city%20lights%20at%20night%20with%20long%20exposure%20light%20trails%2C%20data%20flow%20concept%2C%20warm%20golden%20and%20white%20lights%2C%20dark%20background%2C%20motion%20blur%20effect%2C%20modern%20city%20aesthetic%2C%20no%20people%2C%20cinematic%20mood&width=1600&height=900&seq=privacy-hero-tokyo-night&orientation=landscape"
          alt="データの流れ"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-primary-900/80" />
        <div className="relative z-10 h-full flex flex-col justify-end pb-12 md:pb-16 px-6 md:px-12 lg:px-20">
          <div className="max-w-[1280px] mx-auto w-full">
            <div className="inline-block px-4 py-1.5 rounded-full border border-white/30 mb-5">
              <span className="text-white/90 text-xs md:text-sm tracking-[0.2em] font-sans font-light">個人情報保護</span>
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-white tracking-[0.06em]">
              プライバシーポリシー
            </h1>
          </div>
        </div>
      </section>

      {/* Policy Grid */}
      <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-heading font-light text-foreground-950 tracking-[0.06em]">
              データ処理の原則
            </h2>
            <p className="text-sm text-foreground-500 tracking-[0.08em] font-sans font-light">4つのコアポリシー</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {policies.map((p) => (
              <div key={p.tag} className="group cursor-pointer">
                <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute top-3 right-3">
                    <span className="inline-block px-3 py-1 rounded-full bg-primary-900/70 backdrop-blur-sm text-accent-400 text-[11px] md:text-xs tracking-[0.1em] font-sans font-light">{p.tag}</span>
                  </div>
                </div>
                <div className="mt-4 space-y-1">
                  <h3 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">{p.title}</h3>
                  <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Long Text Content */}
      <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-100">
        <div className="max-w-[960px] mx-auto">
          <div className="rounded-lg bg-background-50 p-8 md:p-12 lg:p-16 space-y-10">
            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第1条（個人情報の収集方法）</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当社は、ユーザーがお問合わせフォームや資料請求フォームを通じてご提供いただく情報（会社名、氏名、メールアドレス、電話番号等）を収集します。また、当社ウェブサイトの利用状況に関する情報を、Cookie等の技術を用いて自動的に収集する場合があります。
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第2条（個人情報の利用目的）</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当社が収集した個人情報は、以下の目的で利用いたします。<br />
                1. お問合わせに対する回答および資料送付<br />
                2. 当社サービスの提供および改善<br />
                3. 当社サービスに関する情報提供<br />
                4. 利用状況の分析によるウェブサイト改善<br />
                5. 法令に基づく対応
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第3条（安全管理措置）</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当社は、個人情報の漏洩、滅失または毀損の防止その他の安全管理のために必要かつ適切な措置を講じています。具体的には、アクセス制御、暗号化通信（SSL/TLS）の導入、従業員教育の実施等の対策を行っています。
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第4条（第三者提供）</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当社は、以下の場合を除き、個人情報を第三者に提供することはありません。<br />
                1. 本人の同意がある場合<br />
                2. 法令に基づく場合<br />
                3. 人の生命、身体または財産の保護のために必要がある場合<br />
                4. 公衆衛生の向上または児童の健全な育成のために特に必要がある場合<br />
                5. 国の機関等の法令の定める事務への協力が必要な場合
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第5条（開示・訂正・削除）</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当社は、本人から個人情報の開示、訂正、追加、削除、利用停止を求められた場合、本人確認を行った上で、法令に従い速やかに対応いたします。
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第6条（お問合わせ窓口）</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                本ポリシーに関するお問合わせは、下記までご連絡ください。<br /><br />
                株式会社バンクカード・チェック 個人情報保護管理者<br />
                〒100-0005 東京都千代田区丸の内1丁目5-1 新丸の内ビルディング 12F<br />
                Email: admin@bankcard-chcak.jp<br />
                TEL: 03-5215-8420
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第7条（改定）</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当社は、必要に応じて本ポリシーを改定することがあります。改定後のポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </article>

            <p className="text-xs text-foreground-400 tracking-[0.06em] font-sans font-light pt-4">
              制定日：2015年4月1日<br />
              最終改定日：2026年4月1日
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
        <div className="max-w-[1280px] mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-light text-foreground-950 tracking-[0.06em]">
            個人情報保護管理者への連絡
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 tracking-[0.08em] font-sans font-light">
            開示・訂正・削除の請求はこちら
          </p>
          <div className="mt-6">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-800 text-accent-400 text-sm md:text-base tracking-[0.08em] font-sans font-medium hover:bg-primary-700 transition-all duration-300 cursor-pointer whitespace-nowrap">
              問合せる
              <i className="ri-arrow-right-line text-lg" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}